import './App.css';

function JoinUs() {
  return (
      <div className="contentDiv">
        <h1 className="contentHeader">Join Us</h1>
        <h3 className="contentSubHeader">Requirements</h3>
        <ul className="contentSubHeader">
            <li>Be enrolled in a degree program at UNM as either an undergraduate or a graduate student.</li>
            <li>Be in good academic standing and enrolled full time.</li>
            <li>Have a general interest in the sport of powerlifting and a desire to compete.</li>
        </ul>
        <h3 className="contentSubHeader">Steps to Join Us</h3>
        <ol className="contentSubHeader">
            <li><a href="https://unm.presence.io/organization/lobo-powerlifting">Click here</a> to join our club officially on UNM Presence. </li>
            <li>Email <a href="mailto:lobopowerlifting@clubs.unm.edu">lobopowerlifting@clubs.unm.edu</a> asking us for further steps to join the team.</li>
        </ol>
      </div>
  );
}

export default JoinUs;
